import { getGBUrl } from '../../utils/config';
import { getFetch } from '../../utils/fetch';

export const getLatestActivityLaunch = async (studentId, courseId) => {
  const gradebookV1Url = `${getGBUrl()}/api/v1`;
  try {
    const response = await getFetch(
      `${gradebookV1Url}/launches/courses/${courseId}/users/${studentId}`,
    );

    if (!response.ok) {
      throw new Error(`Server request failed with status ${response.status}`);
    }

    return response.json();
  } catch (error) {
    console.error('Error fetching latest activity timestamp:', error);
    return null;
  }
};
